import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { getLatestComics } from '@/mocks/comics';

export default function LatestSection() {
  const latestComics = getLatestComics();

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日新鲜内容，精彩不容错过</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}